module.exports = __webpack_public_path__ + "img/Ski_Challenge_small_detail.c00eb668.png";